import template from './teamCalendarListCard.html';
import controller from './teamCalendarListCard.controller';
import './teamCalendarListCard.scss';

let teamCalendarListCardComponent = {
  restrict: 'E',
  bindings: {
    card: '<',
    isDisabledIncept: '<',
    hasDelegated: '<',
    delegation: '<'
  },
  template,
  controller
};

export default teamCalendarListCardComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/teamCalendarList/teamCalendarListCard/teamCalendarListCard.component.js